import { Link, MenuItem, MenuList, Typography } from '@packages/shared';
import { useConfig } from '@packages/utilities';
import { useIntl } from 'react-intl';
import useSWR from 'swr';
import { headerDefaultFetcher } from '../../api';

interface ServiceMenuEntry {
  translatable_title: string;
  translatable_url: string;
  is_external: boolean;
}

interface ServiceMenuData {
  [key: string]: ServiceMenuEntry;
}

const useServiceMenuData = (serviceApi: string | undefined) => {
  const { locale } = useIntl();
  const { data } = useSWR<ServiceMenuData>(
    serviceApi!.replace('<locale>', locale.split('-')[0]),
    headerDefaultFetcher,
    { suspense: true },
  );
  // after swr correctly implements suspense pattern, remove non-null assertion operator
  return Object.values(data!).slice(0, -1);
};

export const ServiceSlotMenuList = () => {
  const {
    headerSlots: { serviceApi },
    i18n: { defaultLocale },
  } = useConfig();

  const data = useServiceMenuData(serviceApi);

  return (
    <MenuList>
      {data.map(({ translatable_title, translatable_url, is_external }) => (
        <Link
          href={translatable_url.replace(`/${defaultLocale.substring(0, 2)}/`, '/')}
          key={translatable_title}
          noLinkStyle
          openInNewTab={is_external}
        >
          <MenuItem>
            <Typography variant="body2">{translatable_title}</Typography>
          </MenuItem>
        </Link>
      ))}
    </MenuList>
  );
};
